import { render, staticRenderFns } from "./class-select.vue?vue&type=template&id=22c50952&scoped=true"
import script from "./class-select.vue?vue&type=script&lang=ts"
export * from "./class-select.vue?vue&type=script&lang=ts"
import style0 from "./class-select.vue?vue&type=style&index=0&id=22c50952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c50952",
  null
  
)

export default component.exports